(function () {
  var modals = document.querySelectorAll(".auth-modal");
  if (!modals.length) return;

  function closeAll() {
    modals.forEach(function (modal) {
      modal.classList.remove("is-open");
    });
    document.body.classList.remove("modal-open");
  }

  function open(name) {
    closeAll();
    var modal = document.querySelector('.auth-modal[data-modal="' + name + '"]');
    if (!modal) return;
    modal.classList.add("is-open");
    document.body.classList.add("modal-open");
  }

  document.querySelectorAll("[data-open-modal]").forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      open(trigger.getAttribute("data-open-modal"));
    });
  });

  document.querySelectorAll("[data-modal-close]").forEach(function (btn) {
    btn.addEventListener("click", closeAll);
  });

  var overlay = document.querySelector("[data-modal-overlay]");
  if (overlay) overlay.addEventListener("click", closeAll);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeAll();
  });
})();
